import type Task from '../schema/Task';
import { toSubtodo } from './toSubtodo';
import {
    Todo,
    TaskImportance,
    TaskStatus,
    LinkedEntity,
    LinkedEmail,
    EMAIL_ENTITY_TYPE,
} from 'owa-todo-types';
import { userDate, utcDate, getYear, getMonth, getDate } from 'owa-datetime';
import { convertRestIdToEwsId } from 'owa-identifiers';

export function toTodo(taskItem: Task): Todo {
    let todoItem = {
        ...taskItem,
        __type: 'Todo',
        ReminderDateTime: taskItem.ReminderDateTime
            ? userDate(taskItem.ReminderDateTime.DateTime)
            : undefined,
        CompletedDateTime: taskItem.CompletedDateTime
            ? userDate(taskItem.CompletedDateTime.DateTime)
            : undefined,
        DueDateTime: taskItem.DueDateTime ? userDate(taskItem.DueDateTime.DateTime) : undefined,
        OrderDateTime: taskItem.OrderDateTime ? userDate(taskItem.OrderDateTime) : undefined,
        Status: taskItem.Status as TaskStatus,
        Subtasks: taskItem.Subtasks ? taskItem.Subtasks.map(toSubtodo) : undefined,
        Importance: taskItem.Importance as TaskImportance,
        Note:
            taskItem.Body?.Content && taskItem.Body.ContentType == 'Text'
                ? taskItem.Body.Content
                : undefined,
        LinkedEmail: getLinkedEmailEntity(taskItem.LinkedEntities),
        CommittedDay: taskItem.CommittedDay
            ? getCommittedDayDate(taskItem.CommittedDay)
            : undefined,
        CommittedOrder: taskItem.CommittedOrder ? userDate(taskItem.CommittedOrder) : undefined,
        CreatedWithLocalId: taskItem.CreatedWithLocalId ? taskItem.CreatedWithLocalId : undefined,
    } as Todo;

    return taskItem ? todoItem : null;
}

function getCommittedDayDate(dateStr: string) {
    // The Task committed date string is in UTC format, but it is supposed to be used as if
    // it were time zone agnostic.
    const dateLie = utcDate(dateStr);
    // We make a new date object according to the date indicated in the Task in whichever time zone the user has set.
    // We do this because we can only answer "isSame***" questions if we are looking at dates in the same time zone.
    const dateInUserTz = userDate(getYear(dateLie), getMonth(dateLie), getDate(dateLie));
    return dateInUserTz;
}

function getLinkedEmailEntity(linkedEntities: [LinkedEntity]): LinkedEmail {
    if (!linkedEntities) {
        return null;
    }

    const emailEntities = linkedEntities.filter(entity => entity.EntityType == EMAIL_ENTITY_TYPE);
    return emailEntities.length == 0 ? null : toLinkedEmail(emailEntities[0]);
}

function toLinkedEmail(linkedEntity: LinkedEntity): LinkedEmail {
    return {
        Id: convertRestIdToEwsId(linkedEntity.Id),
        EntitySubtype: linkedEntity.EntitySubtype,
        DisplayName: linkedEntity.DisplayName,
    };
}
